// This to improving performance/fix bugs on iOS Safari
// Read more at https://react-dnd.github.io/react-dnd/docs/backends/touch (in getDropTargetElementsAtPoint section)
const getDropTargetElementsAtPoint = (x: any, y: any, dropTargets: any) =>
  dropTargets.filter((t: any) => {
    const rect = t.getBoundingClientRect();

    return (
      x >= rect.left && x <= rect.right && y <= rect.bottom && y >= rect.top
    );
  });

// This function to check the iOS browsers to return the getDropTargetElementsAtPoint function
export const getDropTargetElementsByPlatform = () => {
  const hasNative =
    // @ts-ignore
    document && (document.elementsFromPoint || document.msElementsFromPoint);

  return !hasNative && getDropTargetElementsAtPoint;
};



// WEBPACK FOOTER //
// ./src/services/dragNDrop.ts